import React from 'react'
import moment from '../../../lib/moment.js'
import styled from 'styled-components'
import get from 'lodash/get'
import { Button } from 'reactstrap'
import { FONTS, COLORS } from '../../../constants'

export default class CalendarNav extends React.Component {
  state = { moment: get(this.props, 'moment') }

  today = () => {
    this.set(moment())
  }

  left = () => {
    this.set(moment(this.state.moment.add(-1, get(this.props, 'range') || 'month')))
  }

  right = () => {
    this.set(moment(this.state.moment.add(1, get(this.props, 'range') || 'month')))
  }

  set = (_moment) => {
    this.setState({ moment: _moment })
    if (get(this.props, 'onChange')) get(this.props, 'onChange')(_moment)
  }

  render() {
    return (
      <DivNavCalendar>
        <ArrowButton onClick={ this.left }>&#65308;</ArrowButton>
        <ArrowButton onClick={ this.today }>Today</ArrowButton>
        <ArrowButton onClick={ this.right }>&#65310;</ArrowButton>
        {this.state && this.state.moment &&
          <DivMonth>
            <LabelMonth>
              {this.state.moment.format('MMMM')} {this.state.moment.format('YYYY')}
            </LabelMonth>
          </DivMonth>
        }
      </DivNavCalendar>
    )
  }
}

const ArrowButton = styled(Button)`
  height: 30px;
  margin-left: 2%;
  margin-top: 0%;
  padding-top: 0px;
  padding-bottom: 0px;
  background-color: #ffffff;
  color: ${COLORS.BLACK};
  font-size: ${FONTS.SMALL_SIZE};
`
const DivNavCalendar = styled.div`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
`
const LabelMonth = styled.p`
  width: max-content;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin: 0;
  margin-left: 10px;
  margin-right: 10px;
  color: ${COLORS.BLACK};
`
const DivMonth = styled.div`
  font-size: ${FONTS.SMALL_SIZE};
  color: ${COLORS.BLACK};
`



// WEBPACK FOOTER //
// ./src/components/kawari-calendar/components/calendar-nav.js